import { useTranslation } from 'react-i18next';
import { Alert } from '../../services/data';
import AlertCard from './AlertCard';
import Card from '../ui/Card';

interface AlertListProps {
  alerts: Alert[];
}

export default function AlertList({ alerts }: AlertListProps) {
  const { t } = useTranslation();

  if (alerts.length === 0) {
    return (
      <Card>
        <p className="text-gray-500 text-center py-8">{t('alerts.noAlerts')}</p>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {alerts.map((alert) => (
        <AlertCard key={alert.id} alert={alert} />
      ))}
    </div>
  );
}
